import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { FileQuestion } from 'lucide-react';

export const NotFoundPage = () => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4 animate-fade-in">
      <Card className="max-w-md w-full shadow-soft">
        <CardContent className="pt-8 pb-8 text-center">
          <div className="flex justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center">
              <FileQuestion className="w-8 h-8 text-muted-foreground" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-foreground mb-2">
            {t('pageNotFound')}
          </h1>
          <p className="text-muted-foreground mb-6">
            {t('pageNotFoundDescription')}
          </p>
          <Button asChild>
            <Link to="/dashboard">{t('dashboard')}</Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};
